import { motion } from 'motion/react';
import { forwardRef, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TKey } from '~/lib/i18n-locales';
import type { IconComponent } from '~/modules/common/icons/types';
import { Badge } from '~/modules/ui/badge';
import { Button, type ButtonProps } from '~/modules/ui/button';

type Props = { icon: IconComponent; label: TKey; badge?: ReactNode } & ButtonProps;

export const TableBarButton = forwardRef<HTMLButtonElement, Props>(function TableBarButton({ icon: Icon, label, badge, className, ...props }, ref) {
  const { t } = useTranslation();
  return (
    <Button
      {...props}
      render={
        <motion.button
          ref={ref}
          className={className}
          transition={{ bounce: 0, duration: 0.3, ease: 'easeOut' }}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.6, opacity: 0 }}
        />
      }
    >
      {Icon && <motion.span className="flex items-center">{<Icon />}</motion.span>}
      {label && <span>{t(label)}</span>}

      {badge && <Badge context="button">{badge}</Badge>}
    </Button>
  );
});
